import { Avatar, Box, Drawer, IconButton } from "@mui/material";
import { rqx } from "../../../core/request/API";
import { env } from "../../../core/Env";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { NoComment } from "../../../core/global/EmptyState";
import { Loader } from "../publication/view/comment/Loader";
import { KeyboardBackspace } from "@mui/icons-material";
import { timeFormat } from "../../../core/global/Format";

export const Comment = ({ decodePath, showComment, setShowComment }) => {
    const [commentList, setCommentList] = useState([]);
    const [expandedComments, setExpandedComments] = useState({});
    const [isLoad, setIsLoad] = useState(false);

    const getComment = async () => {
        setIsLoad(true);
        const data = await rqx.get(`<<tool>>/${env()}/psl/publicationComment/readComment`,{ publication_id: decodePath, lastId: 0, limit: 100 });
        console.log(data);
        setCommentList(data);
        setIsLoad(false);
    };

    useEffect(() => {
        getComment();
        // eslint-disable-next-line
    }, []);

    const cleanCommentFormat = (comment, id) => {
        let text = comment;

        if (!/<[a-z][\s\S]*>/i.test(text)) {
            text = text.replace(/\n/g, "<br />");
            text = text.replace(
                /(https?:\/\/[^\s]+)/g,
                '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
            );
        }

        const sanitized = DOMPurify.sanitize(text, {
            ALLOWED_TAGS: [
                "p", "a", "br", "strong", "em", "ul", "ol", "li",
                "h1", "h2", "h3", "blockquote", "dl", "dt", "dd", "pre", "code", "dfn", "span"
            ],
            ALLOWED_ATTR: ["href", "target", "rel", "cite"]
        });

        // ✅ If not expanded and too long, truncate and add See more
        if (!expandedComments[id] && sanitized.length > 500) {
            return `${sanitized.slice(0, 500)}...<span style="color:#1976d2;cursor:pointer;font-size:12px;" data-id="${id}">See more</span>`;
        }

        return sanitized;
    };

    const handleClick = (e) => {
        const id = e.target.getAttribute("data-id");
        if (id) {
            setExpandedComments((prev) => ({
                ...prev,
                [id]: true
            }));
        }
    };

    return (
        <Drawer open={showComment} anchor="right" onClose={() => setShowComment(false)}>
            <Box p="16px">
                <IconButton onClick={() => setShowComment(false)}>
                    <KeyboardBackspace />
                </IconButton>
            </Box>
            <Box
                className="publication-scrollbar"
                sx={{
                    height: "100vh",
                    width: "500px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "32px",
                    p: "24px",
                    overflow: "auto"
                }}
            >
                {isLoad ? (
                    <Box my="24px" display="flex" flexDirection="column" gap="24px">
                        {Array(3)
                            .fill(0)
                            .map((_, i) => (
                                <Loader key={i} />
                            ))}
                    </Box>
                ) : commentList.length > 0 ? (
                    commentList.map((v, i) => (
                        <Box key={v.id || i} display="flex" flexDirection="column" gap="16px">
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Avatar src={v.profile !== null ? JSON.parse(v.profile).profile : null} sx={{ width: "32px", height: "32px" }}/>
                                    <Box>
                                        <Box fontSize="12px" fontWeight="600">{`${v.first_name} ${v.last_name}`}</Box>
                                        <Box fontSize="11px" color="#9BA0A6">{timeFormat(v.created_at)}</Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box
                                sx={{ fontSize: "14px" }}
                                onClick={handleClick}
                                className="story-html"
                                dangerouslySetInnerHTML={{
                                    __html: cleanCommentFormat(v.comment, v.id)
                                }}
                            />
                        </Box>
                    ))
                ) : (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" my="24px">
                        <NoComment />
                        <Box display="flex" flexDirection="column" alignItems="center" gap="8px">
                            <Box color="#42465A" fontSize="14px" fontWeight="600">
                                No comments yet
                            </Box>
                            <Box color="#747D8E" fontSize="12px">
                                Great opportunity to start the conversation, let's hear your thoughts!
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </Drawer>
    );
};